import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Input as FormInput } from '../../../components/Form/Input';
import { withInputClassNames } from '../HOC';
import { FieldArray } from 'formik';
import { Button } from '../../Button';
const Input = withInputClassNames(FormInput);

const isChecked = (reference, value) => reference.checkboxes.includes(value);
const refCheckHandler = (target, value, refIndex, refs, updateFormInfo) => {
  const checked = refs[refIndex].checkboxes;
  if (target.checked) checked.push(value);
  else {
    const index = refs[refIndex].checkboxes.indexOf(value);
    checked.splice(index, 1);
  }
  refs[refIndex].checkboxes = checked;
  const event = { target: { name: 'references', value: refs } };
  updateFormInfo(event);
};

export const ReferencesCard = ({
  formInfo,
  updateFormInfo,
  editable,
  reference,
  referenceIndex,
}) => {
  const [showReferenceInfo, setShowReferenceInfo] = useState(false);

  return (
    <div className="col-12 col-lg p-0">
      {!editable ? (
        <React.Fragment>
          <a
            className="t-16 my-4 d-block"
            href={reference.link}
            target="_blank"
          >
            {reference.link}
          </a>
          <p className="t-14 text-gray-light mb-1">You Liked</p>
          <p className="t-14 text-darkgreen">
            {reference.checkboxes.join(', ')}
          </p>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="reference-input-container desktop-remove">
            <Input
              label="Reference (Enter website address)"
              name={`references[${referenceIndex}].link`}
              onChange={e => {
                let refs = formInfo.references;
                refs[referenceIndex].link = e.target.value;
                const event = { target: { name: 'references', value: refs } };
                updateFormInfo(event);
              }}
              hasInput={!!reference.link}
              onClick={() => {
                setShowReferenceInfo(!showReferenceInfo);
              }}
            />
          </div>
          <div className="reference-input-container mobile-remove">
            <Input
              label="Reference (Enter website address)"
              name={`references[${referenceIndex}].link`}
              onChange={e => {
                let refs = formInfo.references;
                refs[referenceIndex].link = e.target.value;
                const event = { target: { name: 'references', value: refs } };
                updateFormInfo(event);
              }}
              hasInput={!!reference.link}
            />
            <Button
              className="btn btn-md t-14 btn-back"
              onClick={() => {
                const refs = _.cloneDeep(formInfo.references);
                refs[referenceIndex]['_destroy'] = true;
                const event = {
                  target: { name: 'references', value: refs },
                };
                updateFormInfo(event);
              }}
            >
              <i className="icon icon-clearer text-gray-light t-20" />
            </Button>
          </div>
          <div
            className={`reference-addition-info ${
              showReferenceInfo ? 'show' : 'hide'
            }`}
          >
            <div className="reference-info-wrapper">
              <p className="t-14 font-weight-bold text-darkgreen">
                What do you like about this reference video?
              </p>
              <FieldArray
                name={`references[${referenceIndex}].checkboxes`}
                render={array => (
                  <div className="reference-card__checkboxes mb-3 row">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        name={`references[${reference.id}].checkboxes[0]`}
                        id={`colorCheck_${referenceIndex}`}
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Colors',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        value="Colors"
                        defaultChecked={isChecked(reference, 'Colors')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`colorCheck_${referenceIndex}`}
                      >
                        Colors
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name={`references[${referenceIndex}].checkboxes[7]`}
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Pacing',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        className="custom-control-input"
                        id={`pacingCheck_${referenceIndex}`}
                        value="Pacing"
                        defaultChecked={isChecked(reference, 'Pacing')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`pacingCheck_${referenceIndex}`}
                      >
                        Pacing
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name={`references[${referenceIndex}].checkboxes[5]`}
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Transitions',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        className="custom-control-input"
                        id={`transitionsCheck_${referenceIndex}`}
                        value="Transitions"
                        defaultChecked={isChecked(reference, 'Transitions')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`transitionsCheck_${referenceIndex}`}
                      >
                        Transitions
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name={`references[${referenceIndex}].checkboxes[4]`}
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Voiceover',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        className="custom-control-input"
                        id={`voiserCheck_${referenceIndex}`}
                        value="Voiceover"
                        defaultChecked={isChecked(reference, 'Voiceover')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`voiserCheck_${referenceIndex}`}
                      >
                        Voiceover
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name={`references[${referenceIndex}].checkboxes[3]`}
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Music',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        className="custom-control-input"
                        id={`musicCheck_${referenceIndex}`}
                        value="Music"
                        defaultChecked={isChecked(reference, 'Music')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`musicCheck_${referenceIndex}`}
                      >
                        Music
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Tone',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        name={`references[${referenceIndex}].checkboxes[2]`}
                        className="custom-control-input"
                        id={`toneCheck_${referenceIndex}`}
                        value="Tone"
                        defaultChecked={isChecked(reference, 'Tone')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`toneCheck_${referenceIndex}`}
                      >
                        Tone
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name={`references[${referenceIndex}].checkboxes[8]`}
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Graphic Effects',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        className="custom-control-input"
                        id={`graphicEffects_${referenceIndex}`}
                        value="Graphic Effects"
                        defaultChecked={isChecked(reference, 'Graphic Effects')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`graphicEffects_${referenceIndex}`}
                      >
                        Graphic Effects
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Style',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        name={`references[${referenceIndex}].checkboxes[1]`}
                        className="custom-control-input"
                        id={`styleCheck_${referenceIndex}`}
                        value="Style"
                        defaultChecked={isChecked(reference, 'Style')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`styleCheck_${referenceIndex}`}
                      >
                        Style
                      </label>
                    </div>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name={`references[${referenceIndex}].checkboxes[6]`}
                        onChange={e => {
                          refCheckHandler(
                            e.target,
                            'Setting',
                            referenceIndex,
                            formInfo.references,
                            updateFormInfo,
                          );
                        }}
                        className="custom-control-input"
                        id={`settingCheck_${referenceIndex}`}
                        value="Setting"
                        defaultChecked={isChecked(reference, 'Setting')}
                      />
                      <label
                        className="custom-control-label t-14"
                        htmlFor={`settingCheck_${referenceIndex}`}
                      >
                        Setting
                      </label>
                    </div>
                  </div>
                )}
              />
              <div className="remove-reference">
                <a
                  onClick={() => {
                    const refs = _.cloneDeep(formInfo.references);
                    refs[referenceIndex]['_destroy'] = true;
                    const event = {
                      target: { name: 'references', value: refs },
                    };
                    updateFormInfo(event);
                  }}
                >
                  <i className="icon icon-close" />
                  Remove reference
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 p-0 my-4">
            <div className="col p-0">
              <hr className="mt-0 project-separator references" />
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

ReferencesCard.propTypes = {
  reference: PropTypes.object,
  referenceIndex: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/ProjectView/ReferenceCard/ReferenceCard.js